import { createFileRoute } from '@tanstack/react-router';

import { ScreenStub } from '@/components/layout/ScreenStub';

export const Route = createFileRoute('/communities')({
  component: Screen,
});

function Screen() {
  return (
    <ScreenStub
      eyebrow="Moderation & membership"
      title="Communities"
      capability="communities.view"
      planned="List and detail with members, roles, channels, posts, announcements and recaps; the moderation triage queue (keyboard shortcuts on desktop, swipe actions on mobile); and the join-request queue with bulk approve/deny."
    />
  );
}
